export default __webpack_public_path__ + "static/drawing_thumbnail-9cae972d79a3fc047a21250d950886fd.svg";